var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 350,
        width: 630,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "10",
          y: "42",
          rx: "3",
          ry: "3",
          width: "588.5",
          height: "100",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "20",
          rx: "1",
          ry: "1",
          width: "200",
          height: "19",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "478",
          y: "20",
          rx: "3",
          ry: "3",
          width: "120",
          height: "18",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "180",
          rx: "3",
          ry: "3",
          width: "588.5",
          height: "100",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "10",
          y: "158",
          rx: "1",
          ry: "1",
          width: "200",
          height: "19",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "478",
          y: "158",
          rx: "3",
          ry: "3",
          width: "120",
          height: "18",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }